<template>
  <div>
    <el-collapse v-model="sizeActiveNames">
      <el-collapse-item
        v-if="request_prefix === 'bigScreen' || (request_prefix !== 'bigScreen' && isDraggable && !isAutoLayoutElement) || isPhoneFullScreen"
        :title="request_prefix === 'bigScreen' ? '位置尺寸' : '位置'"
        name="1"
      >
        <div class="content clearFloat">
          <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="position" @updateBefore="updateBefore" />
        </div>
      </el-collapse-item>
         <el-collapse-item title="尺寸" name="2" v-if="request_prefix !== 'bigScreen' && isResizable && !showRowColSize && !showGridSize && sizeVal && !(isAutoLayoutElement && customShapes.includes(options.innerElement))  || isPhoneFullScreen">
         <template slot="title">
          尺寸
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialog=true"></i>
        </template>
        <div class="content clearFloat">
          <widthAndSizeAndZindex :options="options" :ids="ids"  :showSetItem="sizeVal" @updateBefore="updateBefore" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="尺寸" name="2" v-else-if="request_prefix !== 'bigScreen' && !isAutoLayoutElement && !showRowColSize && showGridSize  || isPhoneFullScreen">
        <template slot="title">
          尺寸
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialog=true"></i>
        </template>
        <div class="content clearFloat">
          <widthAndSizeAndZindex :options="options" :ids="ids" :showGrid="showGridSize" :showSetItem="sizeVal"  @updateBefore="updateBefore" />
        </div>
      </el-collapse-item>
      <rowColLayoutSize :options="options" :ids="ids" v-if="request_prefix !== 'bigScreen' && ( isAutoLayoutElement && customShapes.includes(options.innerElement) || showRowColSize)" :disableAuto="disableAutoShapes.includes(options.innerElement)"/>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog lineHeight32">
      <p class="fs14 tips mb24"><span>尺寸单位：</span>支持px（像素）、百分比、适应内容和充满布局等多种单位方式，根据不同组件属性可以选择不同的尺寸单位。</p>
      <p class="fs14 tips ">例如：</p>
      <p class="fs14 tips"><span>常规组件：</span>可以设置px和百分比单位，px可以设置为组件固有尺寸，不可超出布局大小；百分比单位为所在布局尺寸的等比大小。</p>
      <p class="fs14 tips mb24"><span>自适应组件：</span>除了px和百分比，还可以设置适应内容和充满布局单位，适应内容是指内容有序排列下，根据内容多少决定当前组件的大小，没有固定值，例如“张三”和“张小三”在相同样式设置下，宽度是不同的；充满布局类似百分比设置为100%，但本身也是根据不同的布局显示不同的大小，区别是多个组件之间可以相互影响。</p>
      <p class="fs14 tips ">需要注意：</p>
      <p class="fs14 tips"><span>组件宽度：</span>在内容区中的组件宽度会自适应最合适的宽度，可能出现输入100px，最终生成120px。</p>
      <p class="fs14 tips"><span>自适应单位：</span>如果子组件设置为充满，所在布局则不能设置适应内容。</p>
<!--      <div class="box">-->
<!--        <video src="https://mh.chaoxing.com/sv2/assets/video/size.mp4" controls></video>-->
<!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "./widthAndSizeAndZindex"
import { isInAutoLayout, findPathInComponentLayoutByRectId, findCurrentComponentPathInLayoutByRectId, elementInComplexComponent } from "utils"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
export default {
  components: { widthAndSizeAndZindex, rowColLayoutSize },
  props: {
    ids: {
      type: Object
    },
    options: Object
  },
  data() {
    return {
      sizeActiveNames: ["1", "2"],
      sliderMax: 360,
      this1: this,
      // colIsAutoLayout: false,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      explainDialog: false,
      customShapes: [
        "cxText", "cxNavMenuVertical", "cxLogicText", "cxNavMenu", "cxWeather", "cxDate", "cxMultiFilter", "cxButton", "cxIcon", "imageComponent", "cxVideo", "cxAudio", "cxTabs", "cxLabel", "cxHomeLine", "cxVerticalLine", "cxIframe", "cxTable", "cxBar", "cxLine", "cxPie", "cxRadar", "cxCloud", "emptyLayoutComponent", "cxEditor", "cxBreadCrumbs", "cxNoteEditor", "cxCalendar", "cxSelect", "cxIframe", "swiperComponent", "cxInput", "cxAnchorComponent", "cxPagination", "cxDigitRoll", "cxAutoLayout", "cxSort","cxShare",
        "cxCountdown"
      ],
      disableAutoShapes: [
        "emptyLayoutComponent", "cxIframe", "cxHomeLine", "cxVerticalLine", "cxBar", "cxLine", "cxPie", "cxPie3D", "cxRadar", "cxCloud", "imageComponent", "cxIcon", "cxCalendar", "cxCode", "cxIframe", "swiperComponent"
      ],
      // isAutoLayoutElement: false,
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxCode",
        "cxAutoLayout",
        "cxDatePicker",
        "cxInput",
        "cxPagination",
        // "cxNavMenu"
        "cxAnchorComponent",
        "cxIP",
        "cxSort",
        "cxShare",
        "cxCountdown"
      ],
    }
  },
  computed: {
    currentPageLayout() {
      const path = findCurrentComponentPathInLayoutByRectId(
        this.$store.state[this.request_prefix].page.pageLayoutList || [],
        this.ids.rect_id
      )[0]
      let pageLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          pageLayoutId: path
        },
        "pageLayout"
      )
      return pageLayout || {}
    },
    isWaterFall() {
      let isWaterFall =
        this.$store.state[this.request_prefix].page.isWaterFall === "waterFall" &&
        !this.currentPageLayout.options?.popoverParams
          ? true
          : false
      return isWaterFall
    },
    showGridSize(){
      // todo 待优化   布局标签里的自由布局不能设置尺寸
      // 判断是不是标签布局等通栏组件内的组件 不能设置尺寸
      const parentPath = findPathInComponentLayoutByRectId(this.ids)
      const isLayoutComponent = this.isWaterFall && parentPath && parentPath[0]
       if(this.isWaterFall && !this.baseComponent.includes(this.options.innerElement) && !isLayoutComponent && !elementInComplexComponent(this.ids)){
         return true
       }
       return false
    },
    sizeVal(){
      if(this.options?.innerElement === "cxPagination" ||  this.options.menuName?.trim() === '分页'){
        return  false
      }
      return "size"
    },
    showRowColSize() {
      return ["cxTabs", "cxCountdown"].includes(this.options?.innerElement)
    },
    isDraggable() {
      if(!this.isWaterFall && this.options.innerElement === 'cxIframe'){
        // 老布局模式下，iframe是当做基础组件来处理的
        return true
      }
      if(this.baseComponent.indexOf(this.options.innerElement) === -1){
        if(this.options.pluginName?.indexOf("ListPageSearchComponentPlugin") >-1){
          return  true
        }
        if (this.options.hasOwnProperty("elementInLayoutId")) return true // 复杂组件拖入单元格中 也要支持位置尺寸设置 比如导航菜单
        return  false
      }
      if (this.options && (!this.options.hasOwnProperty("draggable") || this.options.draggable === undefined)) {
        return true
      }
      return this.options.draggable
    },
    isResizable() {
      if(!this.isWaterFall && this.options.innerElement === 'cxIframe'){
        // 老布局模式下，iframe是当做基础组件来处理的
        return true
      }
      // 复杂组件内部的组件 都要支持设置尺寸
      if (elementInComplexComponent(this.ids)) return true
      if(this.baseComponent.indexOf(this.options.innerElement) === -1){
        if(this.options.pluginName?.indexOf("ListPageSearchComponentPlugin") >-1){
          return  true
        }
        return  false
      }
      if (this.options && (!this.options.hasOwnProperty("resizable") || this.options.resizable === undefined)) {
        return true
      }
      return this.options.resizable
    },
    // 翻页模板
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isAutoLayoutElement() {
      /* 是否在自动布局中 */
      return isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options) || false
    }
  },
  mounted() {
    // this.colIsAutoLayout = sessionStorage.getItem("colIsAutoLayout")
    /* 是否在自动布局中 */
    // this.isAutoLayoutElement = isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options)
    if (this.ids?.hasOwnProperty("elementInLayoutId")) {// 登录框下的iframe
      this.baseComponent = [...this.baseComponent , "cxIframe"]
    }
  },
  methods: {
    updateBefore(args) {
      this.$emit("updateBefore", args)
    }
  }
}
</script>

<style scoped>
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.color000 {
  color: var(--text);
}
::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
</style>
